module.exports = __webpack_public_path__ + "img/login_bgdTwo.81c72872.png";